import lottie from 'lottie-web';
import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay, Grid, Navigation, Pagination } from 'swiper/modules';
import {
  toPercentTime,
  toPercentTimeDesc,
  updateQueryStringParameter
} from '../../../../common/utils/convertUtil';

export default function liveBox(props) {
  const [liveTab, setLiveTab] = useState(0);
  const [swiperRef, setSwiperRef] = useState(null);

  const [activeIndex, setActiveIndex] = useState(0);

  // live icon json 
  useEffect(() => {
    lottie.loadAnimation({
      container: document.querySelector('.icon_live'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'https://static.cloud.sbs.co.kr/libs/lottie/live_icon_ani.json'
    });
  }, []);

  useEffect(() => {
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);

  //link로그를
  const handleClick = (a, b, c, d) => {
    let conver_current_s = parseInt(c);
    let conver_current_s2 = parseInt(props.loc_idx);
    let moduleSubTitle;
    let contentTitle;
    let contentId;
    let channelname;



    if (liveTab == 0) {
      moduleSubTitle = '실시간라이브';
      contentTitle = b.title;
      contentId = b.channelid;
      channelname = b.channelname;
    }else if (liveTab == 1) {
      moduleSubTitle = '24시간TV';
      contentTitle = b.title;
      contentId = b.channelid;
      channelname = b.channelname;
    } else {
      moduleSubTitle = '전체채널';
      contentTitle = '';
      contentId = '';
      channelname = b.channelname;
    }

    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '라이브', //모듈 아이디 없으면
        moduleTitle: '실시간라이브/24시간TV', //모듈 제목 (Require)
        moduleSubTitle: moduleSubTitle,
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: conver_current_s2, //페이지에서 해당 모듈의 위치
        moduleItemSeq: conver_current_s, //모듈 내에서 콘텐츠의 위치
        programId: b.pgm_id, //프로그램의 아이디 (추가)
        programTitle: contentTitle, //프로그램의 제목 (추가)
        contentId: contentId, //식별자
        contentTitle: channelname, //콘텐츠의 제목  (Require)
        contentType: 'L', //콘텐츠의 타입 (별도 표 참조)
      },
    });
  };

  const handleClick_custom = (a, b, c, d) => {
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    let name;
    if (liveTab == 0) {
      name = '라이브전체채널';
    }else{
      name = '24시간TV전체채널';
    }

    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: name,
        clickType: 'NC',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };

  const topContents1 = props.data.contents1[0];
  const topContents2 = props.data.contents2[0];
  const nextContents1 = props.data.contents1_sub[0];
  const nextContents2 = props.data.contents2_sub[0];

  const calculateProgress = (item) => {
    if (!item.starttime || !item.endtime) return null;

    const percent = toPercentTime(item.starttime, item.endtime);
    return percent < 0 || percent > 100 ? null : percent;
  };

  const topContent = liveTab === 0 ? topContents1 : topContents2;
  const nextContent = liveTab === 0 ? nextContents1 : nextContents2;

  const progressPercent = calculateProgress(topContent);
  const progressDesc = progressPercent
    ? toPercentTimeDesc(topContent.starttime, topContent.endtime, progressPercent)
    : '';

  const dataToUse = liveTab === 0 ? props.data.contents1.slice(1) : props.data.contents2.slice(1);

  const grouped = dataToUse.reduce((acc, item, idx) => {
    const groupIndex = Math.floor(idx / 4);
    if (!acc[groupIndex]) acc[groupIndex] = [];
    acc[groupIndex].push(item);
    return acc;
  }, []);

  const handleOpenPopupTop = () => {
    window.open(
      topContent.talk_link,
      '타이틀명을 입력하시오',
      'top=0, left=0, width=485, height=928, status=no, menubar=no, toolbar=no, resizable=no'
    );
  }

  const normalizedTitle = topContent.title?.replace(/\s+/g, '');

  // listModuleItem swiper-slide first-item
  return (
    <>
      <div className="mainContents-typeWhite">
        {/* 탭영역 */}
        <div className="contentsBlock_w">
          <div className="moduleTitleline_w">
            <div className="moduleTitleline_linkType">
              <h2 className="moduleTitleline-Title">
                <a
                  href="#none"
                  onClick={() => setLiveTab(0)}
                  className={`moduleTitleline-link${liveTab == 0 ? ' current' : ''
                    }`}
                >
                  <span className="icon_live"></span>
                  실시간 라이브
                </a>
              </h2>
              <span className="moduleTitleline-Dot"></span>
              <h2 className="moduleTitleline-Title">
                <a
                  href="#none"
                  onClick={() => setLiveTab(1)}
                  className={`moduleTitleline-link${liveTab == 1 ? ' current' : ''
                    }`}
                >
                  24시간 TV
                </a>
              </h2>
            </div>
            <a
              href={props.data.alllink_url}
              onClick={(e) => handleClick_custom(e, '', '0', 'all')}
              className="moduleTitleline-linkMore"
              style={{
                visibility:
                  props.data.alllink_yn == 'Y' &&
                    props.data.alllink_url != '' &&
                    props.data.alllink_url != null
                    ? 'visible'
                    : 'hidden',
              }}
            >
              {props.data.alllink_title}
            </a>
          </div>

          <>

            <div className={'listModule_w_live live' + props.loc_idx}>
              {topContent &&
                <div className="liveSpotCont_left">
                  <div className="moduleBoxWrap_live">
                    <a
                        href={topContent.url_link}
                        onClick={(e) => handleClick(e, topContent, 0, 'live')}
                        className="mb_link"
                    >
                      <div className="mb_image_w">
                        <div className="mb_image_inner">
                          <img
                            src={topContent.img_url}
                            className="mb_image"
                            alt={topContent.title}
                          />
                        </div>
                        <div className="mb_progress_w">
                          <i className="hide">라이브 총시간 및 진행시간</i>
                          <span
                            className="mb_progress"
                            style={{ width: `${progressPercent}%` }}
                            title={progressDesc}
                          ></span>
                        </div>
                        <div className="mb_label_w">
                          {(topContent.channelid === 'S17' || topContent.channelid === 'S18') && (
                            <span className="mb_label_bora">보라</span>
                          )}
                        </div>
                      </div>
                      <div className={`mb_cont ${topContent.channelid === 'S01' && normalizedTitle === '방송종료'
                        ? ''
                        : 'active'
                        }`}>
                        <div className="img-con01">
                          <img
                            className="img"
                            src={
                              liveTab === 0
                                ? (topContents1.sum_img || '//image.board.sbs.co.kr/2025/04/24/oiY1745481401179.png')
                                : '//image.board.sbs.co.kr/2025/04/24/oiY1745481401179.png'
                            }
                            alt={topContent.title}
                          />
                          <span className="ico-label05-live">
                            <span className="txt01">라이브</span>
                          </span>
                        </div>
                        <i className="img-con02"></i>
                        <div className="mb_info_w">
                          <span className="mbif_title">{topContent.title}</span>
                          {!(topContent.channelid === 'S01' && normalizedTitle === '방송종료') && (
                            <span class="mbif_subinfo"><span class="txt01">{`${topContent.starttime} ~ ${topContent.endtime}`}</span><span class="txt01">{topContent.channelname}</span></span>
                          )}
                        </div>
                      </div>
                    </a>
                    <div className="moduleBottomBtns">
                      <a href="#none" className="btnType-playtalk" onClick={handleOpenPopupTop}
                      ><span className="iconSvg_playtalk"></span            ><strong className="btnType-title">플레이톡</strong></a>
                    </div>
                  </div>
                  <a
                    href={liveTab === 0 ? 'https://www.sbs.co.kr/schedule/index.html' : '#none'}
                    onClick={(e) => {
                      if (liveTab !== 0) {
                        e.preventDefault();
                      }
                    }}
                    className="moduleBoxWrap_next"
                  >
                    <div className="mb_title_next">다음방송</div>
                    <div className="mb_info_w">
                      <span className="mbif_title">{nextContent.title}</span>
                      <span className="mbif_subinfo"
                      >{nextContent.starttime} ~ {nextContent.endtime}</span>
                    </div>
                  </a>
                </div>
              }
              <div className={"listGridModule_w_type1 live" + props.loc_idx}>
                <button
                  type="button"
                  aria-label="다음 콘텐츠 보기"
                  className="btnTypeList-Next swiper-button-next"
                  onClick={() => {
                    swiperRef?.slideNext();
                  }}
                >
                  <span className="iconSvg_arrow">
                    <i className="hide">다음</i>
                  </span>
                  <span className="pagingNumber_w">
                    <strong className="pagingNumber-now">
                      {activeIndex + 1}
                    </strong>
                    /{grouped.length}
                  </span>
                </button>
                <div className="listGridModuleSlider">
                  <Swiper
                    onSwiper={(swiper) => {
                      setSwiperRef(swiper);
                      setActiveIndex(swiper.realIndex);  // Swiper 초기화 시 realIndex로 페이지 번호 설정
                    }}
                    onSlideChange={(swiper) => {
                      setActiveIndex(swiper.realIndex);  // 페이지 변경 시 realIndex 업데이트
                    }}
                    slidesPerView={1}
                    slidesPerGroup={1}
                    spaceBetween={0}
                    loop={true}
                    pagination={{
                      el: `.live${props.loc_idx} .swiper-pagination`,
                      clickable: false,
                    }}
                    navigation={{
                      nextEl: `.live${props.loc_idx} .swiper-button-next`,
                      prevEl: `.live${props.loc_idx} .swiper-button-prev`,
                    }}
                    wrapperClass="SliderContent"
                    className="listModuleItem"
                    modules={[Pagination, Navigation]}
                  >
                    {grouped.map((group, groupIdx) => (
                      <SwiperSlide key={groupIdx} className="listModuleItem">
                        {group.map((item, index) => {
                          const isFirstItemInSlide = index === 0;
                          const progressPercent =
                            item.starttime && item.endtime
                              ? toPercentTime(item.starttime, item.endtime)
                              : null;
                          const validPercent =
                            progressPercent > 100 || progressPercent < 0 ? null : progressPercent;
                          const progressDesc = validPercent
                            ? toPercentTimeDesc(item.starttime, item.endtime, validPercent)
                            : '';

                          const handleOpenPopup = () => {
                            window.open(
                              item.talk_link,
                              '타이틀명을 입력하시오',
                              'top=0, left=0, width=485, height=928, status=no, menubar=no, toolbar=no, resizable=no'
                            );
                          };

                          return (
                            <div
                              key={index}
                              className={`moduleBoxWrap_live${isFirstItemInSlide ? ' first-item' : ''}`}
                            >
                              <a
                                href={item.url_link}
                                onClick={(e) => handleClick(e, item, index, 'live')}
                                className="mb_link"
                              >
                                <div className="mb_image_w">
                                  <div className="mb_image_inner">
                                    <img src={item.img_url} className="mb_image" alt={item.title + ' ' + item.channelname} />
                                  </div>
                                  <div className="mb_progress_w">
                                    <i className="hide">라이브 총시간 및 진행시간</i>
                                    <span
                                      className="mb_progress"
                                      style={{ width: `${validPercent}%` }}
                                      title={progressDesc}
                                    ></span>
                                  </div>
                                  <div className="mb_label_w">
                                    {(item.channelid === 'S17' || item.channelid === 'S18') && (
                                      <span className="mb_label_bora">보라</span>
                                    )}
                                  </div>
                                </div>
                                <div className="mb_info_w">
                                  <span className="mbif_title">{item.title}</span>
                                  <span className="mbif_subinfo">{item.channelname}</span>
                                </div>
                              </a>
                              {<div className="moduleBottomBtns">
                                <a href="#none" onClick={handleOpenPopup} className="btnType-playtalk">
                                  <span className="iconSvg_playtalk"></span>
                                  <strong className="btnType-title">플레이톡</strong>
                                </a>
                              </div>}
                            </div>
                          );
                        })}
                      </SwiperSlide>
                    ))}
                  </Swiper>


                  <div className="swiper-pagination"></div>
                  <button
                    type="button"
                    aria-label="이전 콘텐츠 보기"
                    className="btnTypeList-Prev swiper-button-prev"
                    onClick={() => {
                      swiperRef?.slidePrev();
                    }}
                  >
                    <span className="iconSvg_arrow">
                      <i className="hide">이전</i>
                    </span>
                    <span className="pagingNumber_w">
                      <strong className="pagingNumber-now">
                        {activeIndex + 1}
                      </strong>
                      /{grouped.length}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
}
